import React, { forwardRef } from "react";
import { BSDiv } from "../../types";

export const Accordion = forwardRef<HTMLDivElement, BSDiv>(
  ({ children, className = "", ...props }, ref) => {
    return (
      <div {...props} className={`accordion ${className}`} ref={ref}>
        {children}
      </div>
    );
  }
);